import type { FormEvent, ReactNode } from "react";

export interface LoginProps {
  /** 产品名与环境标记。 */
  brand: ReactNode;
  title: ReactNode;
  onSubmit: () => void;
  /** 自上而下：失败时的 Alert、字段、占满宽度的主按钮。 */
  children: ReactNode;
}

/** 登录页：没有外壳，页面底色上居中一块窄面板，回车提交。 */
export function Login({ brand, title, onSubmit, children }: LoginProps) {
  const submit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };
  return (
    <div className="ax-auth">
      <form className="ax-auth-panel" onSubmit={submit} noValidate>
        <div className="ax-auth-brand">{brand}</div>
        <h1 className="ax-auth-title">{title}</h1>
        {children}
      </form>
    </div>
  );
}
